import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useTranslation } from 'react-i18next';
import { ContainerVertical, Text, SectionTitle } from '@aftersale-next/ui';
import { x } from '@xstyled/styled-components';
import { BsX } from 'react-icons/bs';
import { useAppMode } from '../../hooks/use-app-mode';
export default function ChannelConfirmationMessage() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useAppMode = useAppMode(),
      _useAppMode2 = _slicedToArray(_useAppMode, 2),
      mode = _useAppMode2[0],
      setMode = _useAppMode2[1];

  return /*#__PURE__*/_jsxs(ContainerVertical, {
    padding: "5px",
    justify: "flex-start",
    align: "flex-start",
    children: [/*#__PURE__*/_jsxs(x.div, {
      pb: "32px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      w: "100%",
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: t('DELIVERY_NOTIFICATIONS')
      }), /*#__PURE__*/_jsx(x.button, {
        onClick: function onClick() {
          return setMode('tracking');
        },
        color: "gray-600",
        fontSize: "x-large",
        focusOutline: "none",
        children: /*#__PURE__*/_jsx(BsX, {})
      })]
    }), /*#__PURE__*/_jsx(Text, {
      children: t('WE_KEEP_YOU_UPDATED')
    })]
  });
}